import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"more\"><defs><style type=\"text/css\"></style></defs><path d=\"M736 512c0 8-3.2 16-9.6 22.4l-384 384c-12.8 12.8-32 12.8-44.8 0-12.8-12.8-12.8-32 0-44.8L659.2 512 297.6 150.4c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l384 384c6.4 6.4 9.6 14.4 9.6 22.4z\" p-id=\"2193\" fill=\"#bfbfbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/more.svg
// module id = w7Cr
// module chunks = 38